import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Table } from "../../../Table/Table";
import Loading from "../../../Loadings/LoadingTable";
import { MdDeleteForever, MdNotificationsActive } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import Button from "../../../Button/Button";
import {
  useGetRockedListProduct,
  useUpdateStatusRockedProduct,
} from "../../../../hooks/useContent";
import { useRecoilState, useRecoilValue } from "recoil";
import Spinner from "react-bootstrap/Spinner";

import {
  ContentUnitModal,
  RefreshTableBrand,
} from "../../../../shared/content-unit";
import { Link } from "react-router-dom";
import Typography from "../../../Typography/Typography";
import { RenderTooltip } from "../../../Tooltip/Tooltip";

function BrandTable() {
  const [refresh, setRefreshEffect] = useRecoilState(RefreshTableBrand);

  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");

  const {
    data: categoryList,
    hasNextPage,
    fetchNextPage,
    isLoading,
  } = useGetRockedListProduct(search, "NotActive");
  const [idOccation, setIdOccation] = useState(-1);

  const {
    mutateAsync: updateStatus,
    isLoading: upLoading,
    error: upError,
  } = useUpdateStatusRockedProduct();

  const [moduals, setModuals] = useRecoilState(ContentUnitModal);

  const pageCount = categoryList?.pages[0]?.data?.count;

  const headerTitle = [
    "#",
    "عنوان محصول",
    "دسته بندی",
    "قیمت یک عدد",
    "تعداد در جین",
    "قیمت کل",
    "برند",
    "تعداد موجودی",
    "کد محصول ",
    "عملیات ",
  ];

  const handleDeleteCatergory = (category) => {
    setModuals({
      ...moduals,
      deleteBrand: { value: category, isShow: true },
    });
  };

  const handleChangeSatus = (item) => {
    setIdOccation(item?.IdOccasions);
    updateStatus(item?.IdOccasions).then((res) => {
      setRefreshEffect(!refresh);
    });
  };

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);

  const baseURlImg = "https://apisalamat.mahanskinclinic.com/thumbnail/Brand/";
  let i = 0;
  const items = categoryList?.pages?.map((page) =>
    page?.data?.Products?.map((item) => (
      <tr key={item?.IdProducts}>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {(i += 1)}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.NameProducts ? item?.NameProducts : ""}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.first_category?.NameCategories
              ? item?.first_category.NameCategories
              : ""}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.PriceProducts ? item?.PriceProducts.toLocaleString() : ""}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.NumberInJeans ? item?.NumberInJeans : ""}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.GeneralPriceProducts
              ? item?.GeneralPriceProducts.toLocaleString()
              : ""}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.brand?.NameBrands ? item?.brand?.NameBrands : "بدون برند"}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.NumberInStock ? item?.NumberInStock : "0"}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.CodeProducts ? item?.CodeProducts : ""}
          </span>
        </td>
        <td>
          <ButtonContainer>
            <RenderTooltip title="حذف محصول">
              <Button
                size="12px"
                bgColor="#C82333"
                small="40px"
                color="#fff"
                style={{
                  marginLeft: "1rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onclick={(e) => {
                  handleDeleteCatergory(item);
                }}
              >
                <MdDeleteForever size={25} />
              </Button>
            </RenderTooltip>
            <RenderTooltip title="ویرایش محصول">
              <Button
                size="12px"
                bgColor="#0D6EFD"
                small="40px"
                color="#fff"
                className="mr-2"
              >
                <Link
                  to={`/dashboard/content-controller/products/editProduct?productId=${item?.IdProducts}`}
                >
                  <Typography>
                    <FiEdit color="#fff" size={20} />
                  </Typography>
                </Link>
              </Button>
            </RenderTooltip>
            <RenderTooltip title="تغییر وضعیت">
              <Button
                size="12px"
                bgColor="#80575b"
                small="40px"
                color="#fff"
                className="mr-2"
                onclick={(e) => {
                  handleChangeSatus(item);
                }}
              >
                {upLoading && idOccation === item?.IdOccasions ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <MdNotificationsActive size={20} />
                )}
              </Button>
            </RenderTooltip>
          </ButtonContainer>
        </td>
      </tr>
    ))
  );

  return (
    <CategoryTableStyle>
      <Table
        headerTitle={headerTitle}
        title={`محصولات راکد (${pageCount || ""})`}
        items={items}
        setSearch={setSearch}
      />
    </CategoryTableStyle>
  );
}

const CategoryTableStyle = styled.div`
  width: 100%;
  margin-top: 1rem;

  .slider-image-table {
    width: 90px;
    height: 60px;
    object-fit: contain;
    border-radius: 0.5rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  gap: 1rem;
`;

export default BrandTable;
